import React from 'react';
import SelectedCheckMark from '@assets/images/drivethru/selectedCheck.svg';
import DefaultVehicleType from '@assets/images/drivethru/vehicleType.png';
import cn from 'classnames';
import { TouchableButton } from '@components/common/Touchable/index';
import style from './DriveThruInfo.module.scss';

const VehicleInfo = ({
  items,
  selectedId,
  onSelect,
  laneCount,
  hasLanes,
  serverAppTheme,
}) => {
  const containerClass = cn(
    style.typeGrid,
    hasLanes && laneCount > 1 ? style.vehicletypecolor : style.vehicletypecolor2
  );

  return (
    <div className={containerClass}>
      {items.map((item, index) => {
        if (item?.menuItemId == null) return null;
        const isSelected = selectedId === item.menuItemId;

        return (
          <TouchableButton
            key={item.menuItemId || index}
            className="btn btn-sm fs_14 fw-600 br-2 py-1 px-2 mb-1 border-0 d-flex align-items-center justify-content-center"
            style={{
              minWidth: '60px',
              height: '35px',
              color: serverAppTheme?.primary_text,
              lineHeight: '1',
              flex: '1 1 auto',
              marginRight: '-9px',
            }}
            onClick={() => onSelect(item.menuItemId)}
            rippleEffect
          >
            <img
              src={item.imageUrl || DefaultVehicleType}
              alt="Vehicle Type"
              style={{ width: '84px' }}
            />
            {isSelected && (
              <img
                src={SelectedCheckMark}
                alt="Selected"
                style={{ position: 'absolute', width: '14px', height: '14px' }}
              />
            )}
          </TouchableButton>
        );
      })}
    </div>
  );
};

export default VehicleInfo;
